import { ID, idDef } from "@kosmod/kit";
import { s } from "@kosmod/pancake";
import { AccountID } from "./account";
import { GameID } from "./game";

export type PlayerID = ID<"player", true>;
export type Player = {
  id: PlayerID,

  name: string,
  account: AccountID,
  game: GameID,
};

export const PlayerID = s.ref<PlayerID>()(idDef);
export const Player = s.ref<Player>()(s.o({
  id: PlayerID,

  name: s.str,
  account: AccountID,
  game: GameID
}))

export type PlayerAction =
  | { type: 'name', name: string }

export const updatePlayer = (player: Player, action: PlayerAction): Player => {
  switch (action.type) {
    case 'name':
      return { ...player, name: action.name };
  }
}
